import React from 'react'

import { useTranslation } from 'react-i18next'

import nfLogoBlack from '@assets/images/icons/noteflight-logo-black.svg'
import nfLogo from '@assets/images/icons/noteflight-logo.svg'

import CompanySection from './CompanySection'
import GeneralSection from './GeneralSection'
import HelpSection from './HelpSection'
import LanguageSection from './LanguageSection'
import LegalSection from './LegalSection'
import MusicSection from './MusicSection'
import SocialSection from './SocialSection'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div data-testid="footer">
      <div className="w-full z-10 mt-[100px] flex flex-row flex-wrap justify-between">
        <div className="flex-1 flex flex-col items-center mx-[40px] mb-4">
          <img
            src={nfLogo}
            role="image"
            alt="Noteflight"
            className="max-w-[185px] w-full h-auto mb-1 dark:block hidden"
          />
          <img
            src={nfLogoBlack}
            role="image"
            alt="Noteflight"
            className="max-w-[185px] w-full h-auto mb-1 block dark:hidden"
          />
          <p className="text-xs text-gray-text">a Hal Leonard Company</p>
        </div>
        <div className="flex flex-wrap px-2 sm:px-8 lg:px-2 lg:justify-around lg:flex-nowrap flex-grow-[3]">
          <HelpSection />
          <GeneralSection />
          <MusicSection />
          <CompanySection />
          <LegalSection />
          <LanguageSection />
          <SocialSection />
        </div>
      </div>
      <p className="px-3 pl-4 mt-12 mb-2 text-xs whitespace-normal sm:pl-12 text-gray-text">
        {t('content.noteflightCopyright', { year: new Date().getFullYear() })}
      </p>
    </div>
  )
}

export default Footer
